// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1_Fjh","footer":"ModalFilter_footer__2jC3S"};